import React from "react";
import SendIcon from "@mui/icons-material/Send";
import { Box, Button, Card, CardContent, Divider, Grid, TextField, Typography } from "@mui/material";

export default function CardSendInvitations({
    event,
    invites,
    emailInputs,
    sending,
    timeRemaining,
    onEmailChange,
    onSendInvitations,
}) {
    if (!event) return null;

    return (
        <Grid size={{ xs: 12 }}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Send Invitations
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    {/* Invitation Counter */}
                    <Box
                        sx={{
                            mt: 2,
                            p: 2,
                            backgroundColor: "rgba(76, 175, 80, 0.16)",
                            borderRadius: 2,
                            border: "1px solid #4caf50",
                            textAlign: "center",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                                justifyContent: "center",
                                p: 2,
                            }}
                        >
                            <TextField
                                label="Email Address *"
                                type="email"
                                value={emailInputs[0] || ""}
                                onChange={(e) => onEmailChange(0, e.target.value)}
                                variant="outlined"
                                disabled={sending || (timeRemaining?.isOver === true)}
                                required
                                sx={{
                                    maxWidth: 300,
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        fontSize: "1rem",
                                        "& fieldset": {
                                            borderWidth: 2,
                                            borderColor: "#4caf50",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#4caf50",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#4caf50",
                                            borderWidth: 2,
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        fontWeight: 600,
                                        "&.Mui-focused": {
                                            color: "#4caf50",
                                        },
                                    },
                                }}
                                slotProps={{
                                    input: {
                                        placeholder: "Enter email address (required)",
                                    },
                                }}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SendIcon />}
                                onClick={onSendInvitations}
                                disabled={
                                    sending ||
                                    timeRemaining?.isOver === true ||
                                    (event && invites.length >= (event.requiredCount || 5) * 2)
                                }
                            >
                                {sending
                                    ? "Sending..."
                                    : timeRemaining?.isOver
                                        ? "Event Ended"
                                        : event && invites.length >= (event.requiredCount || 5) * 2
                                            ? "Limit Reached"
                                            : "Send"}
                            </Button>
                        </Box>

                        {invites.length < (event.requiredCount || 5) * 2 ? (
                            <Typography variant="body2" color="text.secondary">
                                You can send{" "}
                                <Box component="span" sx={{ fontWeight: 600, color: "#4caf50" }}>
                                    {(event.requiredCount || 5) * 2 - invites.length}
                                </Box>{" "}
                                more invitation{((event.requiredCount || 5) * 2 - invites.length) !== 1 ? "s" : ""}
                            </Typography>
                        ) : (
                            <Typography variant="body2" color="text.secondary">
                                You have reached the maximum number of invitations
                            </Typography>
                        )}
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontStyle: "italic" }}>
                            Note: Only{" "}
                            <Box component="span" sx={{ fontWeight: 600, color: "#4caf50" }}>
                                {event.requiredCount || 5}
                            </Box>{" "}
                            people need to join to get {event.rewardMonths || 1} month{event.rewardMonths !== 1 ? "s" : ""} free subscription
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
}

